import api from './api';

const matchService = {
  triggerMatching: async () => {
    return await api.post('/matches/trigger-matching');
  },

  getMyMatches: async () => {
    return await api.get('/matches/my-matches');
  },

  getConnections: async () => {
    return await api.get('/matches/connections');
  },

  getMatchDetails: async (matchId) => {
    return await api.get(`/matches/${matchId}`);
  },

  getMatchConversations: async (matchId) => {
    return await api.get(`/matches/${matchId}/conversations`);
  },

  acceptInvite: async (matchId) => {
    return await api.post(`/matches/${matchId}/accept-invite`);
  },

  rejectMatch: async (matchId) => {
    return await api.post(`/matches/${matchId}/reject`);
  },

  getDirectMessages: async (matchId) => {
    return await api.get(`/matches/${matchId}/messages`);
  },

  sendDirectMessage: async (matchId, content) => {
    return await api.post(`/matches/${matchId}/messages`, { content });
  },

  updateConnectionNote: async (matchId, note) => {
    return await api.put(`/matches/${matchId}/note`, { note });
  },

  deleteConnection: async (matchId) => {
    return await api.delete(`/matches/${matchId}/connection`);
  },

  getUserMatches: async (status = null) => {
    const query = status ? `?status=${status}` : '';
    return await api.get(`/matches/my-matches${query}`);
  },
};

export default matchService;
